import React from 'react'
import cdn from 'src/helper/cdn'

import './index.less'

export default class extends React.Component {

  state = {
    url: ""
  }

  componentWillMount() {
    document.title = '404 error'
    this.setState({
      url: window.location.href
    })
  }
  componentDidMount() {
  }

  render() {

    return (
      <div className='notfound'>
        <img src={cdn(`/assets/common/pic_404@2x.png`)} />
        <p>page not found</p>
        <p>{this.state.url}</p>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// src/component/NotFound/index.js